import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faFile, faMagnifyingGlass, faTrashCanXmark } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, CardActions, DialogContent, DialogTitle, Grid, Modal, Typography, useTheme } from "@mui/material"
import { useState } from "react"
import { MaterialDialog, StyledCardMedia } from "./FormPreviewFileThumbnail.styled"
import { IFormUploadAttachmentProps } from "./formuploadfile.interface"
import { useTranslation } from "react-i18next"
import { fontAwesomeOldXlStyle } from "components/icons/fontAwesomeStyles"

const protectedRoutes = ["/vehicleregistry/vehicles/", "/customer/settings/users/"]

const isImageFile = (fileId: string): boolean => {
  const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "svg", "webp"]
  const fileExtension = fileId?.split(".").pop()?.toLowerCase()
  return imageExtensions.includes(fileExtension || "")
}

const FormPreviewFileThumbnail = (props: IFormUploadAttachmentProps) => {
  const { t } = useTranslation()
  const { fileId, fileName, Data, dontShowDeleteButton, removeFile } = props
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const theme = useTheme()

  const shouldShowDeleteButton =
    !dontShowDeleteButton && !protectedRoutes.some((route) => window.location.href.includes(route))

  const closeModal = () => {
    setDialogOpen(false)
  }

  return (
    <>
      {Data !== null && (
        <>
          <Card>
            {fileName && isImageFile(fileName) ? (
              <>
                <StyledCardMedia
                  component={"img"}
                  sx={{ height: 150 }}
                  alt={`Bild nr ${fileId}`}
                  image={`data:image/png;base64,${Data}`}
                  onClick={() => setDialogOpen(true)}
                />
                <CardActions sx={{ justifyContent: "center" }}>
                  <Button size="small" onClick={() => setDialogOpen(true)}>
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass as IconProp}
                      style={{ color: (theme.palette.secondary) as any[800], marginRight: "5px" }}
                    />
                    <Typography>{t("global.open", "Open")}</Typography>
                  </Button>
                  {shouldShowDeleteButton && removeFile && (
                    <Button size="small" onClick={() => removeFile(fileId)}>
                      <FontAwesomeIcon
                        icon={faTrashCanXmark as IconProp}
                        style={{ color: theme.palette.error.main, marginRight: "5px" }}
                      />
                      <Typography>{t("global.delete", "Delete")}</Typography>
                    </Button>
                  )}
                </CardActions>
              </>
            ) : (
              <Grid container gap={2} alignItems="center">
                <FontAwesomeIcon icon={faFile} style={fontAwesomeOldXlStyle} />
                <Typography variant="paragraphLarge" fontWeight="500">
                  {fileName}
                </Typography>
              </Grid>
            )}
          </Card>
          <Modal open={dialogOpen} onClose={() => closeModal()} aria-labelledby="image">
            <MaterialDialog onClose={closeModal} aria-labelledby="customized-dialog-title" open={dialogOpen}>
              <Grid container justifyContent={"space-between"} alignItems={"center"} flexWrap={"nowrap"}>
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                  {fileName}
                </DialogTitle>
                <Button
                  aria-label="close"
                  onClick={closeModal}
                  color="primary"
                  variant="outlined"
                  sx={{
                    mr: 2
                  }}>
                  {t("global.close", "Close")}
                </Button>
              </Grid>

              <DialogContent>
                <img
                  style={{
                    maxWidth: "100%"
                  }}
                  src={`data:image/jpeg;base64,${Data}`}
                  alt={`${fileName}`}
                  onClick={() => closeModal()}
                />
              </DialogContent>
            </MaterialDialog>
          </Modal>
        </>
      )}
    </>
  )
}

export default FormPreviewFileThumbnail
